import { createSlice } from "@reduxjs/toolkit";
import { getBookAlternativeTherapiesById, updateBookAlternativeTherapiesById, deleteBookAlternativeTherapies,createBookAlternativeTherapies,getAllBookAlternativeTherapies } from "../../API/FormsData/BookAlternativeTherapies";

const initialState = {
    getallBookAlternativeTherapies: [],
    loading: false,
    error: null,
    totalPages: 0,
    currentPage: 1,
};

const bookAlternativeTherapiesSlice = createSlice({
  name: "BookAlternativeTherapies",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBookAlternativeTherapiesById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBookAlternativeTherapiesById.fulfilled, (state, action) => {
        state.loading = false;
        state.getcontactus = [action.payload]; // Flat contactUs object array
        state.error = null;
      })
      .addCase(getBookAlternativeTherapiesById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateBookAlternativeTherapiesById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateBookAlternativeTherapiesById.fulfilled, (state, action) => {
        state.loading = false;
        state.updateBookAlternativeTherapies = [action.payload]; // Flat BookAlternativeTherapies object array
        state.error = null;
      })
      .addCase(updateBookAlternativeTherapiesById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteBookAlternativeTherapies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteBookAlternativeTherapies.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteBookAlternativeTherapies = [action.payload]; // Flat BookAlternativeTherapies object array
        state.error = null;
      })
      .addCase(deleteBookAlternativeTherapies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAllBookAlternativeTherapies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllBookAlternativeTherapies.fulfilled, (state, action) => {
        state.loading = false;
        state.getallBookAlternativeTherapies = action.payload.data;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.page;
      })
      .addCase(getAllBookAlternativeTherapies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createBookAlternativeTherapies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createBookAlternativeTherapies.fulfilled, (state, action) => {
        state.loading = false;
        state.createBookAlternativeTherapies = [action.payload]; // Flat BookAlternativeTherapies object array
        state.error = null;
      })
      .addCase(createBookAlternativeTherapies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default bookAlternativeTherapiesSlice.reducer;